import { AUTHENTICATION_TAGS } from "@/api/authentication.constraints";
import { baseApi } from "@/api/baseApi";

export interface EmailChangeRequestPayload {
  newEmail: string;
  currentPassword: string;
  code?: string;
}

export type EmailChangeRequestResponse =
  | { status: "mfa_required"; channel: "email" | "sms" }
  | { status: "pending"; channel: null };

export interface EmailChangeTokenPayload {
  token: string;
}

export type EmailChangeActionResponse = { status: "confirmed" } | { status: "reverted" };

export const toEmailChangeRequestData = (payload: EmailChangeRequestPayload) => ({
  new_email: payload.newEmail,
  current_password: payload.currentPassword,
  code: payload.code ?? "",
});

export const emailChangeApi = baseApi.injectEndpoints({
  overrideExisting: false,
  endpoints: builder => ({
    requestEmailChange: builder.mutation<EmailChangeRequestResponse, EmailChangeRequestPayload>({
      query: payload => ({
        url: "/pf-auth/email-change/requests",
        method: "POST",
        data: toEmailChangeRequestData(payload),
      }),
    }),
    confirmEmailChange: builder.mutation<EmailChangeActionResponse, EmailChangeTokenPayload>({
      query: data => ({
        url: "/pf-auth/email-change/confirm",
        method: "POST",
        data,
      }),
      invalidatesTags: [AUTHENTICATION_TAGS.AUTHENTICATION_TAG],
    }),
    revertEmailChange: builder.mutation<EmailChangeActionResponse, EmailChangeTokenPayload>({
      query: data => ({
        url: "/pf-auth/email-change/revert",
        method: "POST",
        data,
      }),
      invalidatesTags: [AUTHENTICATION_TAGS.AUTHENTICATION_TAG],
    }),
  }),
});

export const { useRequestEmailChangeMutation, useConfirmEmailChangeMutation, useRevertEmailChangeMutation } =
  emailChangeApi;
